module.exports = __webpack_public_path__ + "static/media/bellabyte-papelaria-administrativa-cartao-vista-papel-timbrado.b01b04e6.jpg";